import React, { HTMLAttributeAnchorTarget }  from "react";
import "./Greeting.css";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Link from "../../components/html/link";
import { greeting } from "../../portfolio";
import { Fade } from "react-awesome-reveal";
import FeelingProud from "./FeelingProud";
import {ThemeProps} from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type GreetingProps = {
  children?: React.ReactNode;
  theme:ThemeProps
};

export default function Greeting({
  children,
  theme,
}: GreetingProps) {
	const { t, i18n } = useTranslation();
  const themeVar = {theme};
  return (
    <Fade direction="left" duration={1000} damping={0.3} triggerOnce={true}>
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: themeVar.theme.text }}>
                {t(greeting.title)}
              </h1>
              {greeting.nickname && (
                <h2 className="greeting-nickname" style={{ color: themeVar.theme.text }}>
                  ( {t(greeting.nickname)} )
                </h2>
              )}
              <p
                className="greeting-text-p subTitle"
                style={{ color: theme.secondaryText }}
              >
                {t(greeting.subTitle)}
              </p>
              {/*  <SocialMedia theme={theme} /> */}
							<div className="row">
								<div className="col-lg-6 mb-5">
		              <div className="portfolio-repo-btn-div right">
		                <Link
		                  text="Auszubildende"
		                  href="/auszubildende"
		                  className="portfolio-repo-btn"
		                />
		              </div>
								</div>
								<div className="col-lg-6 mb-5">
								<div className="portfolio-repo-btn-div">
	                <Link
	                  text="Fachkräfte"
	                  href="/Fachkräfte"
	                  className="portfolio-repo-btn" buttonClass="secondary"
	                />
	              </div>
								</div>
							</div>
														
            </div>
          </div>
          <div className="greeting-image-div">
            {/* <img
							alt="saad sitting on table"
							src={require("../../assests/images/feelingProud.svg")}
						></img> */}
            <FeelingProud theme={themeVar.theme} />
          </div>
        </div>
      </div>
    </Fade>
  );
}
